import { doRequest } from 'services/httpService';
import { origin } from 'helpers/originHelper';

export const getConfig = (): any => {
    return doRequest('GET', `${origin}/config.json`);
};
